module.exports = __webpack_public_path__ + "static/media/about.3bbd6bb6.png";